import { query, types, params, rawString } from 'typed-graphqlify';
import { gql } from '@apollo/client';

export const getLocationTakeawaySalesDataQuery = (location_id: string, dateFrom: string, dateTo: string) => gql`
  ${query({
    locations_by_pk: params(
      { id: rawString(location_id) },
      {
        id: types.string,
        name: types.string,
        orders_takeaway: params(
          {
            where: {
              created_at: { _gte: rawString(dateFrom), _lte: rawString(dateTo) },
              paid: { _eq: true },
            },
          },
          [
            {
              id: types.string,
              order_number: types.string,
              location_id: types.string,
              organisation_id: types.string,
              customer_id: types.string,
              created_by: types.string,
              created_at: types.string,
              paid: types.boolean,
              customer_name: types.string,
              delivery_address: types.string,
              takeaway_type: types.string,
              delivery_postcode: types.string,
              when_for: types.string,
              customer_phone: types.string,
              received: types.boolean,
              total: types.number,
              tax: types.number,
              discounts: types.custom<any[]>(),
              refunds: types.custom<any[]>(),
              service_charge: types.number,
              status: types.string,
            },
          ]
        ),
        orders_takeaway_aggregate: params(
          {
            where: {
              location_id: { _eq: rawString(location_id) },
              created_at: { _gte: rawString(dateFrom), _lte: rawString(dateTo) },
              paid: { _eq: true },
            },
          },
          {
            aggregate: {
              sum: {
                service_charge: types.number,
                tax: types.number,
                total: types.number,
              },
              count: types.number,
            },
          }
        ),
      }
    ),
  })}
`;
